/**
 * Toggles message when clicked
 */
export const infoBlock = () => {
	const infoBlocks = document.querySelectorAll('.info-block img');
	function infoClickHandler() {
		const parent = this.parentElement,
			activeClass = 'info-block__open';
		const isOpen = parent.classList.contains(activeClass);
		if (!isOpen) {
			parent.classList.add(activeClass);
		} else {
			parent.classList.remove(activeClass);
		}
	}

	infoBlocks.forEach((block) => {
		block.addEventListener('click', infoClickHandler);
	});
};
